<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				
		</div>

		<!-- 表格 -->
		



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('accountList.editAccount') : $t('accountList.addAccount')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				<!-- <el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select  :disabled="editIndex > -1" v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				
				
				<el-form-item   :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-radio-group @input="selCloud"  v-model="form.cloud_id" size="small">
						<el-radio-button  v-for="item in agentData.cloud" :key="item.id" :label="item.id" border>{{item.name}}</el-radio-button>

					</el-radio-group>
				</el-form-item>
				
				
				<el-form-item v-if="form.cloud_id"  :label="$t('probuy.server_type')" prop="cloud_id">
					<el-radio-group @input="selOne" v-model="form.server_type" size="small">
						<el-radio-button  v-for="item in classData.one_class" :key="item.id" :label="item.id" border>{{item.name}}</el-radio-button>
				
					</el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="form.server_type"  :label="$t('probuy.regions')" prop="regions">
					
					 <el-tabs v-model="form.area" @tab-click="selArea">
					    <el-tab-pane v-for="item in region" :key="item.value" :label="item.name" :name="item.value">
							
							
							<el-radio-group @input="selAreaDetail"  v-model="form.regions" size="small">
								<el-radio-button  v-for="val in item.data" :key="val.value" :label="val.value" border>{{val.name}}</el-radio-button>
											
							</el-radio-group>
							
						</el-tab-pane>
					    
					  </el-tabs>
					  
					  
					
				</el-form-item>
				
				
				
				<el-form-item  v-if="form.regions" :label="$t('probuy.useArea')" prop="cloud_id">
					<div>
						 <el-checkbox @change="changeUseArea" :true-label="1" :false-label="0" v-model="form.useArea">{{$t('probuy.rand')}}</el-checkbox>
					</div>
					
					<div v-loading="useLoad" v-show="form.useArea==0">
						<el-radio-group  v-model="form.selarea" size="small">
							<el-radio-button  v-for="item in useArea" :key="item.value" :label="item.value" border>{{item.name}}</el-radio-button>
										
						</el-radio-group>
					</div>
					
				</el-form-item>
				
				
				
				
				<!-- <el-form-item   :label="$t('server.type')">
					<el-radio-group  v-model="form.server_type" size="small">
						<el-radio :label="1" border>{{$t('server.type1')}}</el-radio>
						<el-radio :label="2" border>{{$t('server.type2')}}</el-radio>
					
					</el-radio-group>
				</el-form-item> -->
				
			
				
				<el-form-item :label="$t('server.num')" prop="num">
					<el-input v-model="form.num" @input="handleInput" type="number"  :placeholder="$t('server.num')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			
				
				<el-form-item :label="$t('server.pass')" prop="password">
					<el-input v-model="form.password" show-password :placeholder="$t('server.pass_p')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			
				
				
	
				
				
				
				
			
				
			
				
				
				<el-form-item :label="$t('server.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('server.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				},
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/serverList", //列表地址
				delAllUrl: "data/delServerAll", //批量删除地址
				delUrl: "data/delServer", //删除單条地址
				addUrl: "data/addServer", //添加/修改地址
				editStatusUrl:"data/editStatusServer",//修改狀態地址
				agentData:[],
				classData:[],
				region:[],
				tableData: [],
				form: {
					useArea:true
				},
				rules: {
					
					username: [{
						required: true,
						message: this.$t('adminList.usernameRequired'),
						trigger: 'blur',
					}],
					
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					parent: [{
						required: true,
						message: this.$t('accountList.selMainAc'),
						trigger: 'blur',
					}],
					ac_id: [{
						required: true,
						message: this.$t('accountList.inp_ac_id'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
					sup_id:[{
						required: true,
						message: this.$t('new1.selSup'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[],
				useArea:[],
				useLoad:false
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('probuy');
		},
		methods: {
			checkServerDetail(item) {
				console.log(item)
				if(item.load==1){
					return false;
				}
				item.load = 1;
				this.axios.post('/admin/data/checkServerDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					item.ip = list.ip
					item.server_status	= list.server_status
					item.private_ip = list.private_ip
					
					item.load = 0;
				}).catch(err => {
					// 失敗
					item.load = 0;
				})
			},
			 handleInput(val) {
			    if (val > 20) {
			      this.form.num = 20;
			    }
			  },
			  selCloud(e){
				
				let index = this.agentData.cloud.findIndex(item=>item.id == e)
				this.classData = this.agentData.cloud[index].data
				console.log(this.classData)  
			  },
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						num: 1,
						useArea:1,
						password: '',
						cloud_id:'',
						area:'',
						selarea:'',
						regions:'',
						server_type:'',
						remark:''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						sup_id: e.sup_id,
						focus:e.focus,
						username: e.username,
						password: e.password,
						status: e.status,
						odds: e.odds,
						type: e.type,
						ac_id: e.ac_id,
						parent: e.parent,
						money:e.money,
						access_key_id:e.access_key_id,
						secret_access_key:e.secret_access_key,
						money_type:e.money_type,
						remark:e.remark
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			selOne(e){
				//console.log(e)
				this.commonChangeData('server')
				let index  = this.classData.one_class.findIndex(item=>item.id == e)
				//console.log(this.classData.one_class[index].data.length)
				if(this.classData.one_class[index].data.length!=0){
					this.region = this.classData.one_class[index].data
					
					if(this.region.length!=0){
						this.form.area = this.region[0].value
						this.form.regions = this.region[0].data[0].value
					}
				}else{
					let value = this.classData.one_class[index].value
					
					this.axios.post('/admin/data/proBuyData', {
						cloud_id: this.form.cloud_id,
						type:'server',
						server_type:value
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						this.region = list
						this.classData.one_class[index].data = list
						if(this.region.length!=0){
							this.form.area = this.region[0].value
							this.form.regions = this.region[0].data[0].value
						}
						console.log(list)
						
					}).catch(err => {
						// 失敗
					})
				}
				
				
			},
			selArea(tab, event){
				this.commonChangeData('area')
				let index = this.region.findIndex(item=>item.value==this.form.area)
				if(index!=-1){
					this.form.regions = this.region[index].data[0].value
				}
				
			},
			selAreaDetail(e){
				this.commonChangeData('area_detail')
			},
			commonChangeData(type){
				if(type=='server'){
					this.form.regions  = ''
				}
				this.form.useArea = 1
				this.form.selarea = ''
				this.useArea = []
			},
			changeUseArea(e){
				if(e==0){
					
					if(this.useArea.length==0){
						
						this.useLoad = true
						
						this.axios.post('/admin/data/proBuyData', {
							cloud_id: this.form.cloud_id,
							type:'checkUseArea',
							region:this.form.regions
						}, {
							token: true,
						}).then(res => {
							let all = res.data
							let list = all.data.list
							
							this.useArea = list
							this.form.selarea = this.useArea[0].value
							
							this.useLoad = false
							
						}).catch(err => {
							// 失敗
							this.useLoad = false
						})
					}else{
						this.form.selarea = this.useArea[0].value
					}
					
				}
			},
			//公共列表
			commonList(type,id=1) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.agentData = list
	
					
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
